import _get from "lodash/get";
import React, { useContext } from 'react';
import { readableColor } from 'polished';
import { ThemeContext } from 'styled-components';
import { Link } from 'gatsby';
import { ThemeModeContext } from '~theme-provider';
import { Container, Row, Col, Desktop, MobileTablet } from '~layout';
import { AssetRenderer, useHasMounted } from '~helpers';
import { modalPropTypes } from '~modal';
import HeaderContainer from './HeaderContainer';
import LogoContainer from './LogoContainer';
import Inner from './Inner';
import Title from './Title';
import Navigation from '../Navigation';
import headerTheme from '../../styles/headerTheme';
import headerPropTypes from '../../prop-types/headerPropTypes';
import HeaderMenu from '../HeaderMenu';

var Header = function Header(_ref) {
  var headerColors = _ref.headerColors,
      logoPath = _ref.logoPath,
      logoPathAlt = _ref.logoPathAlt,
      logoWidth = _ref.logoWidth,
      title = _ref.title,
      isVertical = _ref.isVertical,
      isFullWidth = _ref.isFullWidth,
      navigationList = _ref.navigationList,
      customNavigationList = _ref.customNavigationList,
      menuModalSecondaryList = _ref.menuModalSecondaryList,
      onClickLinkCallback = _ref.onClickLinkCallback,
      currentPath = _ref.currentPath,
      isBlurred = _ref.isBlurred,
      isBackdropBlurred = _ref.isBackdropBlurred;
  var theme = useContext(ThemeContext);

  var _useContext = useContext(ThemeModeContext),
      themeMode = _useContext.themeMode;

  var hasMounted = useHasMounted();

  var backgroundColor = _get(theme, 'header.backgroundColor', headerTheme.header.backgroundColor);

  var defaultLogoWidth = _get(theme, 'header.logo.width', headerTheme.header.logo.width);

  var renderTitleColor;

  if (headerColors) {
    renderTitleColor = readableColor(headerColors[0], 'dark', 'light', false);
  } else if (themeMode) {
    renderTitleColor = themeMode === 'darkMode' ? readableColor(backgroundColor, 'light', 'dark', false) : readableColor(backgroundColor, 'dark', 'light', false);
  } else {
    renderTitleColor = readableColor(backgroundColor, 'dark', 'light', false);
  }

  var renderLogo = /*#__PURE__*/React.createElement(AssetRenderer, {
    assetPath: headerColors ? readableColor(headerColors[0], logoPath, logoPathAlt, false) : readableColor(backgroundColor, logoPath, logoPathAlt, false),
    assetWidth: logoWidth || defaultLogoWidth
  });

  if (!hasMounted) {
    return null;
  }

  return /*#__PURE__*/React.createElement(HeaderContainer, {
    headerColors: headerColors,
    isVertical: isVertical,
    isBlurred: isBlurred,
    isBackdropBlurred: isBackdropBlurred
  }, /*#__PURE__*/React.createElement(Inner, {
    isVertical: isVertical,
    isFullWidth: isFullWidth
  }, /*#__PURE__*/React.createElement(Container, {
    isFullHeight: false,
    flex: "1 1 auto"
  }, /*#__PURE__*/React.createElement(Row, {
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(LogoContainer, null, (logoPath || logoPathAlt) && /*#__PURE__*/React.createElement(Link, {
    to: "/",
    onClick: onClickLinkCallback
  }, renderLogo), title && /*#__PURE__*/React.createElement(Title, {
    color: renderTitleColor,
    isVertical: isVertical,
    hasLogo: !!(logoPath || logoPathAlt)
  }, title))), (navigationList || customNavigationList) && /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Desktop, null, /*#__PURE__*/React.createElement(Navigation, {
    list: navigationList,
    onClickLinkCallback: onClickLinkCallback,
    currentPath: currentPath
  })), /*#__PURE__*/React.createElement(MobileTablet, null, /*#__PURE__*/React.createElement(HeaderMenu, {
    list: navigationList,
    secondaryList: menuModalSecondaryList,
    onClickLinkCallback: onClickLinkCallback,
    currentPath: currentPath
  })))))));
};

Header.defaultProps = {
  headerColors: null,
  logoPath: null,
  logoPathAlt: null,
  logoWidth: null,
  title: null,
  isVertical: false,
  isFullWidth: false,
  navigationList: null,
  customNavigationList: null,
  menuModalSecondaryList: null,
  onClickLinkCallback: function onClickLinkCallback() {},
  currentPath: undefined,
  isBlurred: false,
  isBackdropBlurred: false
};
export default Header;